import * as NodeRSA from "node-rsa";
import qs from "qs";
import React, { useContext, useEffect, useState } from "react";
import { Col, Container, FormControl, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import MediaQuery from "react-responsive";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";
import Cookies from "universal-cookie";
import ErrorBox from "../../../components/ErrorBox/ErrorBox";
import { ButtonText, Heading, SmallText, Text } from "../../../components/Text";
import { reducer } from "../../../context/";
import actionType from "../../../context/actionType";
import Api from "../../../helpers/Api";
import { Divider } from "../FormScreenStyles";
import { Modal, Overlay } from "./LandingStyles";
const cookies = new Cookies();

interface Props extends RouteComponentProps {}

const InputStyle = {
  fontFamily: "Rambla",
  fontSize: 16,
  marginTop: 22,
  marginBottom: 22,
  borderRadius: 0,
};

const AuthLanding: React.FunctionComponent<Props> = (props) => {
  const { i18n } = useTranslation();
  const isChinese = i18n.language === "zhTW" || i18n.language === "cn";
  const { formReducer, configReducer } = useContext(reducer);
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [salutation, setSalutation] = useState("");
  const [password, setPassword] = useState("");
  const [loggedIn, setLoggedIn] = useState(false);
  const [cookieSid, setCookieSid] = useState("");
  const [name, setName] = useState("");
  const [invalidLoginEmail, setInvalidLoginEmail] = useState(false);
  const [invalidGuestEmail, setInvalidGuestEmail] = useState(false);
  const [loginError, setLoginError] = useState(false);
  const toggleLoadingOverlay = (showLoading: boolean) => {
    configReducer.dispatch({
      type: actionType.config.TOGGLE_LOADING,
      payload: {
        showLoading,
      },
    });
  };

  const i18nToLang = (language) => {
    // default en
    let lang = "en";
    switch (language) {
      case "en":
        lang = "en_HK";
        break;
      case "zhTW":
        lang = "zh_HK";
        break;
      case "cn":
        lang = "zh_CN";
        break;
    }
    return lang;
  };

  // Toby: used in Oauth flow
  const { client_id, redirect_uri, auth_url, client_secret, token_url } = Api;
  const oauthAuthURL = `${auth_url}?client_id=${client_id}&redirect_uri=${redirect_uri}&response_type=code`;

  function handleChangePassword(event: React.ChangeEvent<HTMLInputElement>) {
    setPassword(event.target.value);
  }
  function handleChangeEmail(event: React.ChangeEvent<HTMLInputElement>) {
    setInvalidLoginEmail(false);
    setInvalidGuestEmail(false);
    setEmail(event.target.value);
  }
  // const onClickLogin = () => {
  //   setLoginError(false);
  //   const emailRegex = /^[a-zA-Z0-9]+[\w_\.-]*@[\w\.]*[\w-\.]+\.{1}[a-zA-Z]{2,}$/;
  //   if (!emailRegex.test(email)) {
  //     setInvalidLoginEmail(true);
  //     return;
  //   }
  //   let auth = sessionStorage.getItem("auth");
  //   toggleLoadingOverlay(true);

  //   const headers = {
  //     "Content-Type": "application/json; charset=utf-8",
  //     Authorization: "" + auth,
  //   };
  //   let apiBody = {
  //     username: email,
  //     password,
  //   };

  //   fetch(`${Api.path(window.location)}/user/login`, {
  //     method: "POST",
  //     headers: headers,
  //     body: JSON.stringify(apiBody),
  //   })
  //     .then((result) => {
  //       if (result.status === 401) {
  //         throw "Invalid Session";
  //       }
  //       return result.json();
  //     })
  //     .then((resJson) => {
  //       const { data, msg, code } = resJson;
  //       if (code === 40301) {
  //         throw "Invalid User or Password";
  //       }
  //       logResponse(configReducer.state.debugMode, `user/login: ${msg}`);
  //       if (isInvalidSession(resJson)) {
  //         throw "Invalid Session";
  //       }
  //       const { userId, sessionId } = data;

  //       userInfoBySession(sessionId || userId)
  //         .then(() => props.history.push("/auth/user/donation"))
  //         .catch(console.error);
  //     })
  //     .catch((error: string) => {
  //       if (error === "Invalid User or Password") {
  //         console.error(error);
  //         setLoginError(true);
  //       }
  //       if (error === "Invalid Session") {
  //         resetSession(formReducer);
  //       }
  //       toggleLoadingOverlay(false);
  //     });
  // };
  const onCode = (code) => {
    console.log(`get code ${code}`);

    cookies.set("code", code);
    userInfoBySession({ ciamLoginCode: code })
      .then((user) => {
        console.info(user);
        toggleLoadingOverlay(false);
        setLoggedIn(true);
        setName(
          `${user.userFirstName}` +
            (user.userLastName ? ` ${user.userLastName}` : "")
        );
      })
      .catch((e) => {
        console.error("cannot get userInfo by cookie");
      });
  };
  const encryptToken = (token: string) => {
    const jsEncrypt = new NodeRSA(
      configReducer.state.publicKey,
      "pkcs8-public-pem",
      {
        encryptionScheme: "pkcs1",
      }
    );
    return jsEncrypt.encrypt(token, "base64");
  };
  const userInfoBySession = (payload) => {
    const headers = {
      "Content-Type": "application/json; charset=utf-8",
    };
    return fetch(`${Api.path(window.location)}user/userInfoBySession`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(
        payload
        // {
        // ciamSessionToken: ciamSessionID, // for getting user info directly (bypass authorize url)
        // ciamLoginCode: 'asd' // for code received from Oauth server
        // }
      ),
    })
      .then((response) => {
        return response.json();
      })
      .then((resJson) => {
        const { data, msg, code } = resJson;
        console.log(resJson);
        toggleLoadingOverlay(false);
        if (code === 40301) {
          return Promise.reject("sessionID login error");
        }
        if (msg == "OK") {
          const startTime = new Date();
          if (!!formReducer.state.selectedAsset) {
            sessionStorage.setItem("START_TIME", JSON.stringify(startTime));
          }
          sessionStorage.setItem("SESSION_EMAIL", data.userEmail || "");
          sessionStorage.setItem("SESSION_MOBILE", data.userMobile || "");
          sessionStorage.setItem("SESSION_MOBILECC", data.userMobileCC || "");

          sessionStorage.setItem("SESSION_TOKEN", JSON.stringify(data));
          sessionStorage.setItem(
            "SESSION_SALUTATION",
            data.userSalutation || ""
          );
          // setName(`${user.userFirstName}` + (user.userLastName ? ` ${user.userLastName}` : ''));
          console.log("login response: ", data);
          setLoggedIn(true);
          formReducer.dispatch({
            type: actionType.form.LOGIN_SUCCESSFUL,
            payload: {
              user: {
                email,
              },
              startTime: formReducer.state.selectedAsset
                ? startTime
                : undefined,
            },
          });
          return Promise.resolve(data);
        } else {
          setLoginError(true); // display login red-box message
          return Promise.reject("Response message is not OK");
        }
      });
  };
  // Toby: not detect if comes from form page
  // useEffect(() => {
  //   const token = sessionStorage.getItem("SESSION_TOKEN");
  //   if (token && typeof JSON.parse(token) === "object") {
  //     const user = JSON.parse(token) as UserToken;
  //     setLoggedIn(true);
  //     setName(
  //       `${user.userFirstName}` +
  //         (user.userLastName ? ` ${user.userLastName}` : "")
  //     );
  //   }
  //   const email = sessionStorage.getItem("SESSION_EMAIL");
  //   const salutation = sessionStorage.getItem("SESSION_SALUTATION");
  //   if (!!salutation) {
  //     setSalutation(salutation);
  //   }
  //   // JOSH TODO check if token has email before loadding session_email
  //   if (email) {
  //     setEmail(email);
  //   }
  // }, []);
  useEffect(() => {
    formReducer.dispatch({
      type: actionType.form.SET_SCREEN,
      payload: {
        screen: "login",
      },
    });
  }, []);
  useEffect(() => {
    const asset = sessionStorage.getItem("SELECTED_ASSET");
    const project = sessionStorage.getItem("SELECTED_PROJECT");
    const selected = asset
      ? { selectedAsset: JSON.parse(asset) }
      : project
      ? { selectedProject: JSON.parse(project) }
      : undefined;
    if (selected) {
      formReducer.dispatch({
        type: actionType.form.REFRESH_STAGE,
        payload: {
          nextStep: 2,
          ...selected,
        },
      });
    }
    formReducer.dispatch({
      type: actionType.form.SET_SCREEN,
      payload: {
        screen: "login",
      },
    });
  }, []);
  // useEffect(() => {
  //   console.log(oauthAuthURL);
  //   fetch(oauthAuthURL).then((resp) => {
  //     // final redirect url
  //     console.info({ url: resp.url, status: resp.status });
  //     // if (resp.redirected) {
  //     //   console.info('Unexpected redirect');
  //     // } else {
  //     //   console.info('no redirect');
  //     // }
  //   });
  // }, []);
  useEffect(() => {
    // const ciamSessionID = cookies.get('code');

    const currentURL = window.location.href;
    // craft url according to v0.4_20210524 Section 2.1.1 Spec
    const url = `https://my.westkowloon.hk/s/checking?lang=${i18nToLang(
      i18n.language
    )}&sourceURL=${currentURL}&sourceAction=onload`;
    const { token, checking, code } = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    });
    if (code) {
      onCode(code);
      return;
    }
    if (checking === "checkedNoToken") return;
    if (!token) {
      window.location.href = url;
    }
    if (!!token) {
      userInfoBySession({ ciamSessionToken: token })
        .then((user) => {
          toggleLoadingOverlay(false);
          setLoggedIn(true);
          setName(
            `${user.userFirstName}` +
              (user.userLastName ? ` ${user.userLastName}` : "")
          );
        })
        .catch((e) => {
          console.error("cannot get userInfo by cookie");
        });
    }
    // setCookieSid(ciamSessionID);
    // // console.log(ciamSessionID)
    // if (!!ciamSessionID) {
    //   console.info(`found cookie: ${ciamSessionID}`);
    //   userInfoBySession(ciamSessionID)
    //     .then((user) => {
    //       console.info(user);
    //       toggleLoadingOverlay(false);
    //       setLoggedIn(true);
    //       setName(
    //         `${user.userFirstName}` +
    //           (user.userLastName ? ` ${user.userLastName}` : "")
    //       );
    //     })
    //     .catch((e) => {
    //       console.error("cannot get userInfo by cookie");
    //     });
    // }
    // if(ciamSessionID) {
    //     console.log('userInfoBySession Cookie')
    //     toggleLoadingOverlay(true);
    //     userInfoBySession(ciamSessionID)
    // }
  }, []);
  const renderLoginPanel = (isMobile: boolean = false) => (
    <>
      <Helmet>
        <meta property="og:description" content="Please login" />
      </Helmet>
      {!loggedIn && (
        <>
          <Heading
            white
            style={!isMobile ? { marginTop: 80, marginBottom: 11 } : {}}
          >
            {t("loginFaster")}
          </Heading>
          <Text white style={{ marginBottom: 50 }}>
            {t("existingAccount")}
          </Text>
        </>
      )}
      {loggedIn ? (
        <>
          <Heading style={{ marginTop: 80, textAlign: "center" }} white>{`${t(
            "alreadyLogin",
            { user: name || t("user") }
          )}`}</Heading>

          <Row
            style={{
              padding: 0,
              margin: 0,
              marginTop: 80,
              marginBottom: 40,
              justifyContent: "space-between",
              ...(isMobile ? { flexDirection: "column" } : {}),
            }}
          >
            {!!cookieSid ? (
              <Button
                size={isMobile ? "sm" : "lg"}
                onClick={() =>
                  userInfoBySession(cookieSid)
                    .then(() => props.history.push("/auth/user/donation"))
                    .catch(() => {
                      console.log(
                        "Cookie login failed, now trying session method instead"
                      );
                      props.history.push("/auth/user/donation");
                    })
                }
                style={{
                  marginBottom: isMobile ? 12 : 0,
                  ...(isMobile ? {} : { width: 150 }),
                  height: 57,
                  marginRight: 8,
                  backgroundColor: "#ffffff",
                  borderRadius: 0,
                  borderWidth: 0,
                  fontWeight: "bold",
                  ...(isChinese
                    ? { fontFamily: "Microsoft JhengHei" }
                    : { fontFamily: "Rambla" }),
                  color: `#2c3e50`,
                  fontSize: "20px",
                }}
              >
                {t("yes")}
              </Button>
            ) : (
              <Button
                size={isMobile ? "sm" : "lg"}
                onClick={() => props.history.push("/auth/user/donation")}
                style={{
                  marginBottom: isMobile ? 12 : 0,
                  ...(isMobile ? {} : { width: 150 }),
                  height: 57,
                  marginRight: 8,
                  backgroundColor: "#ffffff",
                  borderRadius: 0,
                  borderWidth: 0,
                  fontWeight: "bold",
                  ...(isChinese
                    ? { fontFamily: "Microsoft JhengHei" }
                    : { fontFamily: "Rambla" }),
                  color: `#2c3e50`,
                  fontSize: "20px",
                }}
              >
                {t("yes")}
              </Button>
            )}
          </Row>
        </>
      ) : (
        <>
          {invalidLoginEmail && (
            <Text style={{ fontSize: 16, color: "red" }}>
              {t("pleaseInputValidEmail")}
            </Text>
          )}
          {/* <FormControl
            placeholder={`${t("email")}`}
            style={{
              ...InputStyle,
              ...(invalidLoginEmail
                ? { borderColor: "red", marginTop: 0 }
                : {}),
            }}
            onChange={(event: any) => handleChangeEmail(event)}
          />
          <FormControl
            placeholder={`${t("password")}`}
            type="password"
            style={InputStyle}
            onChange={(event: any) => handleChangePassword(event)}
          /> */}

          <Button
            size={"lg"}
            onClick={() => {
              // onClickLogin();
              // onSFLogin();
              window.location.href = encodeURI(oauthAuthURL);
            }}
            style={{
              width: 188,
              height: 57,
              backgroundColor: "#ffffff",
              borderRadius: 0,
              borderWidth: 0,
              marginBottom: 22,
            }}
          >
            {/* <ButtonText>{t("login").toUpperCase()}</ButtonText> */}
            <ButtonText>{t("loginViaSalesforce")}</ButtonText>
          </Button>

          {/* <SFpopupComponent url={oauthAuthURL} button={} /> */}
          {loginError && (
            <ErrorBox>
              <SmallText style={{ color: "#6b6b6b" }}>
                {t("incorrectPassword")}
              </SmallText>
            </ErrorBox>
          )}
          <Link
            to="route"
            target="_blank"
            onClick={(event) => {
              event.preventDefault();
              let lang =
                i18n.language === "zhTW"
                  ? "zh_HK"
                  : i18n.language === "cn"
                  ? "zh_CN"
                  : "en_HK";
              window.open(
                //                `http://account-dev.westkowloon.hk/${lang}/my-westkowloon-forgot-password`
                `https://my.westkowloon.hk/s/resetpassword?language=${lang}`
              );
            }}
          >
            <ButtonText
              white
              style={{
                textDecoration: "underline",
                marginBottom: 15,
                marginTop: 22,
                fontWeight: "bold",
              }}
            >
              {`${t("forgotPassword")}`.toUpperCase()}
            </ButtonText>
          </Link>
          <Text white>{t("resetPasswordEmail")}</Text>
        </>
      )}
    </>
  );
  const renderRegisterPanel = (isMobile: boolean = false) => (
    <>
      <Heading style={!isMobile ? { marginTop: 80, marginBottom: 11 } : {}}>
        {t("createAnAccount")}
      </Heading>
      <Text style={{ marginBottom: 28 }}>
        {t("createAccountNote_1")}
        {/* @todo: fix the redirect url */}
        {/* <a
        onClick={()=>{
            const auth = sessionStorage.getItem('auth');
            const returnUrl = `${window.location.origin}/donation/auth/user/landing?auth=${auth}`;
            window.location.href = `http://account-dev.westkowloon.hk/en/my-westkowloon-register?retUrl=${returnUrl}`;
        }}
        style={{
            textDecoration:'underline'
        }}>MyWestKowloon</a> */}
        <span>MyWestKowloon</span>
        {t("createAccountNote_2")}
      </Text>
      <Button
        size={"lg"}
        //                    const returnUrl = `${window.location.href}?auth=${auth}`;

        onClick={() => {
          const auth = sessionStorage.getItem("auth");
          // const returnUrl = `${window.location.origin}/donation/auth/user/donation?auth=${auth}`;
          const returnUrl = `${window.location.origin}/donation/auth/user/landing?auth=${auth}`;

          // window.location.href = `http://account-dev.westkowloon.hk/en/my-westkowloon-register?retUrl=${returnUrl}`;
          //https://my.westkowloon.hk/s/registration
          const targetURL = `https://my.westkowloon.hk/s/registration?callbackURL=${returnUrl}`;
          window.location.href = targetURL;
        }}
        style={{
          width: 188,
          height: 57,
          backgroundColor: "#2c3e50",
          borderRadius: 0,
          marginBottom: 40,
        }}
        variant={"outline-light"}
      >
        <ButtonText white>{t("createAccount")}</ButtonText>
      </Button>

      <Divider />

      <Heading style={{ marginTop: 30, marginBottom: 11 }}>
        {t("checkOutAsGuest")}
      </Heading>
      <Text style={{ marginBottom: 28 }}>{t("checkOutNote")}</Text>
      <FormControl
        placeholder={`${t("email")}`}
        style={{
          ...InputStyle,
          marginBottom: 0,
          ...(invalidGuestEmail ? { borderColor: "red" } : {}),
        }}
        onChange={(event: any) => handleChangeEmail(event)}
      />
      {invalidGuestEmail && (
        <Text style={{ fontSize: 16, color: "red", paddingTop: 8 }}>
          {t("invalidEmail")}
        </Text>
      )}
      <Button
        size={"lg"}
        onClick={() => {
          const emailRegex =
            /^[a-zA-Z0-9]+[\w_\.-]*@[\w\.]*[\w-\.]+\.{1}[a-zA-Z]{2,}$/;
          if (!emailRegex.test(email)) {
            setInvalidGuestEmail(true);
            return;
          }
          const startTime = new Date();
          if (!!formReducer.state.selectedAsset) {
            sessionStorage.setItem("START_TIME", JSON.stringify(startTime));
          }
          sessionStorage.setItem("SESSION_EMAIL", email);
          setLoggedIn(true);
          formReducer.dispatch({
            type: actionType.form.LOGIN_SUCCESSFUL,
            payload: {
              user: {
                email,
              },
              startTime: formReducer.state.selectedAsset
                ? startTime
                : undefined,
            },
          });
          props.history.push("/auth/user/donation");
        }}
        style={{
          width: 188,
          height: 57,
          backgroundColor: "#2c3e50",
          borderRadius: 0,
          marginTop: 28,
        }}
        variant={"outline-light"}
      >
        <ButtonText white>{t("checkOut")}</ButtonText>
      </Button>
    </>
  );
  const spacing = loggedIn
    ? {}
    : {
        xs: 6,
        sm: 5,
        md: 5,
        lg: 5,
      };
  const renderContain = () => {
    return (
      <Container style={{ margin: "0 auto", padding: "0px" }}>
        <MediaQuery query="(max-device-width: 1224px)">
          <div
            style={{
              backgroundColor: "#2c3e50",

              /*
              paddingTop: 120,
              paddingLeft: 14,
              paddingRight: 14,
              paddingBottom: 120,
              */
              padding: 20,
            }}
          >
            {renderLoginPanel(true)}
          </div>
          {!loggedIn && (
            <div
              style={{
                backgroundColor: "#EFEEED",
                /*
                paddingTop: 156,
                paddingLeft: 14,
                paddingRight: 14,
                paddingBottom: 120,*/
                padding: 20,
              }}
            >
              {renderRegisterPanel(true)}
            </div>
          )}
        </MediaQuery>
        <MediaQuery query="(min-device-width: 1224px)">
          <Row
            style={{ margin: "0px", padding: "0px", justifyContent: "center" }}
          >
            <Col
              {...spacing}
              style={{
                // height: '100vh', //'calc(100vh - 91px)',
                backgroundColor: "#2c3e50",
                textAlign: "left",
                padding: "0px 50px 10px",
              }}
            >
              {renderLoginPanel()}
            </Col>
            {
              <Col
                xs={6}
                sm={5}
                md={4}
                lg={4}
                style={{
                  // height: '100vh', //'calc(100vh - 91px)',
                  backgroundColor: "#EFEEED",
                  padding: "0px 50px 10px",
                }}
              >
                {renderRegisterPanel()}
              </Col>
            }
          </Row>
        </MediaQuery>
      </Container>
    );
  };

  return (
    <Overlay>
      <Modal>{renderContain()}</Modal>
    </Overlay>
  );
};

export default withRouter(AuthLanding);
